export interface SessionStorageService {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

export class BrowserSessionStorageService implements SessionStorageService {
  get(key: string): string | null {
    return window.sessionStorage.getItem(key);
  }

  set(
    key: string,
    value: string
  ): void {
    window.sessionStorage.setItem(key, value);
  }

  remove(key: string): void {
    window.sessionStorage.removeItem(key);
  }
}
